import axios from "axios";

import {loadStore, resetStore} from "./mobxLocalStorage";
import config from "./config";
import meStore from "../store/meStore";
import {tz} from "moment-timezone";

const baseUrl = config.getBasePublicUrl() + "api/panel/v1/";
const apiUrl = config.getBasePublicUrl() + "api/v1/";
const baseReportUrl = config.getReportBasePublicUrl() + "api/panel/v1/";

const mainAxios = axios.create({
    baseURL: baseUrl
});
const apiAxios = axios.create({
    baseURL: apiUrl
});
const baseReportAxios = axios.create({
    baseURL: baseReportUrl
});
// axios.defaults.baseURL = baseUrl;
// axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
// axios.defaults.headers.get["Access-Control-Allow-Origin"] = "*";

const baseRequest = {
    queryString: (params, namingRules) => {
        return (
            "?" +
            Object.keys(params)
                .map(key => {
                    const keyCopy = key;
                    const rule = namingRules[key];
                    key = rule ? rule : key;
                    if (!params[keyCopy] || params[keyCopy].length === 0) return;
                    return `${key}=${params[keyCopy]}`;
                })
                .join("&")
        );
    },
    addHeader: token => {
        const timeZone = tz.guess();
        let sessionToken = null;
        const meStoreData = loadStore(null, "meStore");
        sessionToken = meStoreData && meStoreData.sessionToken;
        mainAxios.defaults.headers.common["Authorization"] = "Basic " + (token || sessionToken);
        mainAxios.defaults.headers.common["x-timezone"] = timeZone;
        baseReportAxios.defaults.headers.common["x-timezone"] = timeZone;
        baseReportAxios.defaults.headers.common["Authorization"] =
            "Basic " + (token || sessionToken);
    },
    request: (method, path, params, responseType, config, isReportUrl = false) => {
        return (isReportUrl ? baseReportAxios : mainAxios)({
            method,
            url: path,
            data: params,
            responseType,
            ...config
        })
            .then(result => {
                result.headers.role && meStore.setRole(result.headers.role);
                result.headers["permission-hash"] &&
                    meStore.setPermissionHash(result.headers["permission-hash"]);
                return result;
            })
            .catch(err => {
                if (!err.response) {
                    return {status: 400, data: {message: "Sunucudan yanıt alınamadı."}};
                }
                if (err.response.status === 401) {
                    resetStore("meStore");
                    window.location.reload();
                }
                return err.response;
            });
    },
    apiRequest: (method, path, data, apiKey, token, responseType) => {
        apiAxios.defaults.headers.common["X-API-KEY"] = apiKey;
        if (token) {
            apiAxios.defaults.headers.common["X-AUTH-TOKEN"] = token;
        }
        return apiAxios({method, url: path, data, responseType})
            .then(result => {
                return result;
            })
            .catch(err => {
                if (!err.response) {
                    return {status: 400, data: {message: "Sunucudan yanıt alınamadı."}};
                }
                return err.response;
            });
    },
    get: (path, config, isReportUrl = false) =>
        baseRequest.request("GET", path, null, null, config, isReportUrl),
    post: (path, params, isReportUrl = false) =>
        baseRequest.request("POST", path, params, null, null, isReportUrl),
    put: (path, params, isReportUrl = false) =>
        baseRequest.request("PUT", path, params, null, null, isReportUrl),
    delete: (path, params, isReportUrl = false) =>
        baseRequest.request("DELETE", path, params, null, null, isReportUrl),
    download: (path, params, isReportUrl = false) =>
        baseRequest.request("POST", path, params, "blob", null, isReportUrl),
    patch: (path, params, isReportUrl = false) =>
        baseRequest.request("PATCH", path, params, null, null, isReportUrl),
    uploadFile: (path, file, params = {}) => {
        return new Promise(resolve => {
            const url = baseUrl + path;
            const xhr = new XMLHttpRequest();
            const fd = new FormData();
            xhr.open("POST", url, true);
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    resolve(JSON.parse(xhr.responseText));
                }
            };
            let sessionToken = null;
            const meStoreData = loadStore(null, "meStore");
            sessionToken = meStoreData && meStoreData.sessionToken;
            xhr.setRequestHeader("Authorization", "Basic " + sessionToken);
            fd.append("datas", JSON.stringify(params));
            fd.append("file", file);
            xhr.send(fd);
        });
    }
};
baseRequest.addHeader();
export default baseRequest;
